import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-665e61b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "svg-icon svg-icon-" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "svg-icon svg-icon-" }
const _hoisted_12 = {
  id: "kt_auction_create_properties",
  class: "collapse show"
}
const _hoisted_13 = { class: "card-body border-top p-9" }
const _hoisted_14 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_15 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_16 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "fs-6 text-gray-600" }
const _hoisted_19 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_22 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "svg-icon svg-icon-3" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "svg-icon svg-icon-3" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "modal-footer flex-center" }
const _hoisted_33 = { class: "indicator-label" }
const _hoisted_34 = { class: "indicator-progress" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "modal-footer flex-center" }
const _hoisted_42 = { class: "indicator-label" }
const _hoisted_43 = { class: "indicator-progress" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_ctx.can('create', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('auctionProperties')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-flex btn-light-primary m-2",
              "data-bs-toggle": "modal",
              disabled: !_ctx.createdAuction,
              "data-bs-target": "#kt_modal_new_property"
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewProperty')), 1)
            ], 8, _hoisted_6),
            (_ctx.checkedProperties.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-sm btn-flex btn-light-primary m-2",
                  "data-bs-toggle": "modal",
                  disabled: !_ctx.createdAuction,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen056.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('clone')), 1)
                ], 8, _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.checkedProperties.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-sm btn-flex btn-light-primary m-2",
                  "data-bs-toggle": "modal",
                  disabled: !_ctx.createdAuction,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModalCopy && _ctx.openModalCopy(...args)))
                }, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen054.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('copy')), 1)
                ], 8, _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (!_ctx.createdAuction)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.translate('savingAuctionPropertiesNote')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Datatable, {
              "table-header": _ctx.tableHeader,
              "table-data": _ctx.tableData,
              "rows-per-page": 1000,
              "enable-items-per-page-dropdown": false
            }, {
              "cell-checkbox": _withCtx(({ row: property }) => [
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: property.id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedProperties) = $event))
                  }, null, 8, _hoisted_20), [
                    [_vModelCheckbox, _ctx.checkedProperties]
                  ])
                ])
              ]),
              "cell-index": _withCtx(({ row: property }) => [
                _createTextVNode(_toDisplayString(property.index), 1)
              ]),
              "cell-propertyType": _withCtx(({ row: property }) => [
                _createTextVNode(_toDisplayString(property.propertyType), 1)
              ]),
              "cell-areaName": _withCtx(({ row: property }) => [
                _createTextVNode(_toDisplayString(property.areaName), 1)
              ]),
              "cell-auctionStatus": _withCtx(({ row: property }) => [
                _createTextVNode(_toDisplayString(property.auctionStatus), 1)
              ]),
              "cell-startingPrice": _withCtx(({ row: property }) => [
                _createTextVNode(_toDisplayString(property.startingPrice
                ? new Intl.NumberFormat('en-US').format(property.startingPrice)
                : ''), 1)
              ]),
              "cell-salePrice": _withCtx(({ row: property }) => [
                _createTextVNode(_toDisplayString(property.salePrice
                ? new Intl.NumberFormat('en-US').format(property.salePrice)
                : ''), 1)
              ]),
              "cell-createdAt": _withCtx(({ row: property }) => [
                _createTextVNode(_toDisplayString(property.createdAt), 1)
              ]),
              "cell-isActive": _withCtx(({ row: property }) => [
                (property.isActive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.translate('active')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.translate('inactive')), 1))
              ]),
              "cell-actions": _withCtx(({ row: property }) => [
                _createElementVNode("a", {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_edit_property",
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2",
                  onClick: _withModifiers(($event: any) => (_ctx.editOption(property.id)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                  ])
                ], 8, _hoisted_23),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                  onClick: _withModifiers(($event: any) => (_ctx.toggleStatusProperty(property)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_26, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                  ])
                ], 8, _hoisted_25)
              ]),
              _: 1
            }, 8, ["table-header", "table-data"])
          ])
        ]),
        (_ctx.isModalOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal modal-dialog-centered",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [
              _createElementVNode("div", {
                class: "modal-content",
                onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('dateAndTime')) + ": ", 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Field, {
                      type: "datetime-local",
                      name: "eventDatetime",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      modelValue: _ctx.eventDatetime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.eventDatetime) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "eventDatetime" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("a", {
                    "data-bs-dismiss": "modal",
                    id: "kt_modal_edit_property_cancel",
                    class: "btn btn-white me-3",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  _createElementVNode("button", {
                    ref: "submitButton",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveClone && _ctx.saveClone(...args))),
                    type: "button",
                    id: "kt_modal_edit_property1_submit",
                    class: "btn btn-primary"
                  }, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_34, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_35
                    ])
                  ], 512)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isModalOpenCopy)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "modal modal-dialog-centered",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeModalCopy && _ctx.closeModalCopy(...args)))
            }, [
              _createElementVNode("div", {
                class: "modal-content",
                onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('eventId')) + ": ", 1),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "eventId",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      modelValue: _ctx.eventId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.eventId) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_ErrorMessage, { name: "eventId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("a", {
                    "data-bs-dismiss": "modal",
                    id: "kt_modal_edit_property_cancel",
                    class: "btn btn-white me-3",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeModalCopy && _ctx.closeModalCopy(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  _createElementVNode("button", {
                    ref: "submitButton",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.saveCopy && _ctx.saveCopy(...args))),
                    type: "button",
                    id: "kt_modal_edit_property1_submit",
                    class: "btn btn-primary"
                  }, [
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_43, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_44
                    ])
                  ], 512)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}